export enum VoucherErrorCodes {
  VoucherNoFound = 'Gutschein nicht gefunden.',
}
